import { Text, useBreakpointValue } from "@chakra-ui/react";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { LocationReport, ProductReport, RevenueReport } from "./index";

function SupplierSpecificReportCharts({ reportData, showScopeTotals }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierDashboard.charts"
  });
  const containerFlow = useBreakpointValue({
    xl: "row",
    base: "column"
  });

  const [charts, setCharts] = useState([]);

  useEffect(() => {
    const types = ["revenue", "locationCo2Emissions", "productCo2Emissions"];
    const newChartsValue = [];

    types.forEach(type => {
      if (typeof reportData[type] !== "undefined") {
        switch (type) {
          case "revenue":
            if (reportData[type] && Object.keys(reportData[type]).length > 1) {
              newChartsValue.push(
                <RevenueReport
                  key={"revenue-report"}
                  data={reportData[type]}
                  sourcingCompanyName={reportData?.organizationName ?? ""}
                  containerFlow={containerFlow}
                  showScopeTotals={showScopeTotals}
                />
              );
            }
            break;
          case "locationCo2Emissions":
            newChartsValue.push(
              <LocationReport key={"location-report"} data={reportData[type]} containerFlow={containerFlow} />
            );
            break;
          case "productCo2Emissions":
            newChartsValue.push(
              <ProductReport key={"product-report"} data={reportData[type]} containerFlow={containerFlow} />
            );
            break;
          default:
        }
      }
    });

    setCharts(newChartsValue);
  }, [reportData, containerFlow, showScopeTotals]);

  return (
    charts.length === 0 ?
      <Text fontSize="lg" fontWeight="bold">
        {t("noDataAvailable")}
      </Text> : charts
  );
}

export default SupplierSpecificReportCharts;